import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config/api';
import LoadingScreen from '../components/LoadingScreen';
import { useLang } from '../context/LanguageContext';
import '../styles/Privacy.css';

const Privacy = () => {
  const { nl } = useLang();
  const L = (obj, field) => (nl && obj?.[field + '_nl']) || obj?.[field] || '';
  const [privacyData, setPrivacyData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrivacy = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/api/privacy`);
        setPrivacyData(response.data.data);
      } catch (error) {
        console.error('Error fetching privacy:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchPrivacy();
  }, []);

  if (loading) return <LoadingScreen />;

  return (
    <div className="privacy-page">
      <div 
        className="privacy-banner"
        style={{
          backgroundImage: privacyData?.bannerImage ? `url(${privacyData.bannerImage})` : 'none'
        }}
      >
        <div className="container">
          <h1>{L(privacyData, 'bannerTitle') || (nl ? 'Privacybeleid' : 'Privacy Policy')}</h1>
          <p>{nl ? 'Laatst bijgewerkt' : 'Last updated'}: {privacyData?.lastUpdated ? new Date(privacyData.lastUpdated).toLocaleDateString() : new Date().toLocaleDateString()}</p>
        </div>
      </div>

      <div className="container privacy-content">
        {privacyData?.sections?.length > 0 ? (
          privacyData.sections.map((section, index) => (
            <section key={index}>
              <h2>{L(section, 'title')}</h2>
              <p>{L(section, 'content')}</p>
              {((nl && section.bulletPoints_nl?.length > 0) ? section.bulletPoints_nl : section.bulletPoints)?.length > 0 && (
                <ul>
                  {((nl && section.bulletPoints_nl?.length > 0) ? section.bulletPoints_nl : section.bulletPoints).map((bullet, bulletIndex) => (
                    <li key={bulletIndex}>{bullet}</li>
                  ))}
                </ul>
              )}
            </section>
          ))
        ) : (
          <section>
            <h2>{nl ? 'Informatie die we verzamelen' : 'Information We Collect'}</h2>
            <p>{nl ? 'We verzamelen informatie die u rechtstreeks aan ons verstrekt, waaronder naam, e-mailadres, telefoonnummer, bedrijfsnaam en alle andere informatie die u kiest te verstrekken.' : 'We collect information you provide directly to us, including name, email address, phone number, company name, and any other information you choose to provide.'}</p>
          </section>
        )}
      </div>
    </div>
  );
};

export default Privacy;
